import React from 'react';
import { Save, X } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import FileUpload from '../../components/FileUpload';
import { UNIT_OPTIONS } from './catalogUnits';
import UnitConversionHint from './UnitConversionHint';

const CategoryForm = ({
  editingCategory,
  categoryForm,
  setCategoryForm,
  categoryImage,
  setCategoryImage,
  onSubmit,
  onCancel,
}) => (
  <Card className="mb-6" data-testid="category-form">
    <CardHeader>
      <CardTitle>{editingCategory ? 'Edit Category' : 'Add New Category'}</CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Category Name *</label>
            <Input
              value={categoryForm.name}
              onChange={(e) => setCategoryForm((prev) => ({ ...prev, name: e.target.value }))}
              placeholder="e.g., Fresh Vegetables"
              required
              data-testid="category-name-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Display Order</label>
            <Input
              type="number"
              value={categoryForm.order}
              onChange={(e) => setCategoryForm((prev) => ({ ...prev, order: parseInt(e.target.value) || 0 }))}
              data-testid="category-order-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Default selling unit</label>
            <select
              value={categoryForm.default_unit}
              onChange={(e) => setCategoryForm((prev) => ({ ...prev, default_unit: e.target.value }))}
              className="w-full px-3 py-2 border rounded-md"
              data-testid="category-default-unit-select"
            >
              {UNIT_OPTIONS.map((unit) => <option key={unit.value} value={unit.value}>{unit.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Default unit value</label>
            <Input
              type="number"
              min="0.001"
              step="0.001"
              value={categoryForm.default_unit_value}
              onChange={(e) => setCategoryForm((prev) => ({ ...prev, default_unit_value: e.target.value }))}
              data-testid="category-default-unit-value-input"
            />
          </div>
          <div className="md:col-span-2">
            <UnitConversionHint
              unit={categoryForm.default_unit}
              unitValue={categoryForm.default_unit_value}
              testId="category-unit-conversion-hint"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">Description</label>
            <textarea
              value={categoryForm.description}
              onChange={(e) => setCategoryForm((prev) => ({ ...prev, description: e.target.value }))}
              rows={2}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Category description..."
              data-testid="category-description-input"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-2">Category Image</label>
            <FileUpload
              category="categories"
              files={categoryImage}
              onChange={setCategoryImage}
              multiple={false}
              showPrimary={false}
              sortable={false}
              label="Upload Category Image"
            />
          </div>
          <div className="flex items-center">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={categoryForm.is_active}
                onChange={(e) => setCategoryForm((prev) => ({ ...prev, is_active: e.target.checked }))}
                className="rounded"
                data-testid="category-active-checkbox"
              />
              <span className="text-sm">Active</span>
            </label>
          </div>
        </div>
        <div className="flex gap-2">
          <Button type="submit" data-testid="save-category-btn">
            <Save className="h-4 w-4 mr-2" /> {editingCategory ? 'Update' : 'Create'} Category
          </Button>
          <Button type="button" variant="outline" onClick={onCancel} data-testid="cancel-category-btn">
            <X className="h-4 w-4 mr-2" /> Cancel
          </Button>
        </div>
      </form>
    </CardContent>
  </Card>
);

export default CategoryForm;
